import script from "./Hero.vue?vue&type=script&setup=true&lang=js"
export * from "./Hero.vue?vue&type=script&setup=true&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=56e7a726&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e7a726"]])

export default __exports__